<template>
    <div>
        <div class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <h3>Slider</h3>
                <div class="card">
                  <div class="card-body">
                    <div class="row" v-show="data.tipe == null">
                        <div class="col-md-12">
                          <h3 class="text-center">Maaf, ini hanya untuk fitur yg berlangganan akun Custom</h3>
                        </div>
                    </div>
                    <div class="row" v-show="data.tipe != null">

                        <div class="col-md-12">
                          <h4>Ukuran Asal Persegi panjang aja dah bentuknya, hehe</h4>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="bmd-label-floating">Slider 1</label>
                            <input type="file" class="form-control file-upload" accept="image/*" @change="update.Slider1Change">
                            <input type="hidden" class="form-control" placeholder="Nama..." v-model="data.slider1"> 
                            <div  class="d-block">
                              <small v-show="data.slider1loading"><i>Uploading...</i></small>
                              <small class="text-success" v-show="data.slider1loadingdone"><i>Sudah Terupload. Cek perubahan di aplikasi pelanggan</i></small>
                            </div>
                            <button class="btn btn-sm btn-info" v-show="!data.slider1loadingdone" @click="update.uploadSlider('1')">Upload Slider 1</button>
                          </div>
                          <div class="form-group">
                            <label class="bmd-label-floating">Slider 2</label>
                            <input type="file" class="form-control file-upload" accept="image/*" @change="update.Slider2Change">
                            <input type="hidden" class="form-control" placeholder="Nama..." v-model="data.slider2"> 
                            <div  class="d-block">
                              <small v-show="data.slider2loading"><i>Uploading...</i></small>
                              <small class="text-success" v-show="data.slider2loadingdone"><i>Sudah Terupload. Cek perubahan di aplikasi pelanggan</i></small>
                            </div>
                            <button class="btn btn-sm btn-info" v-show="!data.slider2loadingdone" @click="update.uploadSlider('2')">Upload Slider 2</button>
                          </div>
                          <div class="form-group">
                            <label class="bmd-label-floating">Slider 3</label>
                            <input type="file" class="form-control file-upload" accept="image/*" @change="update.Slider3Change">
                            <input type="hidden" class="form-control" placeholder="Nama..." v-model="data.slider3"> 
                            <div  class="d-block">
                              <small v-show="data.slider3loading"><i>Uploading...</i></small>
                              <small class="text-success" v-show="data.slider3loadingdone"><i>Sudah Terupload. Cek perubahan di aplikasi pelanggan</i></small>
                            </div>
                            <button class="btn btn-sm btn-info" v-show="!data.slider3loadingdone" @click="update.uploadSlider('3')">Upload Slider 3</button>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
      tipe: null,
      slider1: "",
      slider2: "",
      slider3: "",
      slider1loading: false,
      slider2loading: false,
      slider3loading: false,
      slider1loadingdone: false,
      slider2loadingdone: false,
      slider3loadingdone: false,
    })
    const update = {
      form : reactive({
        alert: null,
        alertSuccess: null
      }),
      Slider1Change(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
            data.slider1 = files[0];
            data.slider1loadingdone = false;
      },
      Slider2Change(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
            data.slider2 = files[0];
            data.slider2loadingdone = false;
      },
      Slider3Change(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
            data.slider3 = files[0];
            data.slider3loadingdone = false;
      },
      uploadSlider(Slider) {
        if (data.tipe == null) {
          alert("Maaf, ini hanya untuk fitur yg berlangganan akun Custom")
          return false;
        }
        let datau = new FormData();
        if (Slider == "1") {
            datau.append('image_file', data.slider1);
            data.slider1loading = true;
        }
        if (Slider == "2") {
            datau.append('image_file', data.slider2);
            data.slider2loading = true;
        }
        if (Slider == "3") {
            datau.append('image_file', data.slider3);
            data.slider3loading = true;
        }

        var apiUrl = inter.SliderUploads()+"?token=TangTung "+sessionStorage.getItem('myToken')+"&ke="+Slider;
        myGlobal.callSlider(datau,apiUrl).then(x => {
            //console.log(JSON.stringify(x));
            if (x.status == true) {
                //this.data.List = x.data;

                this.simpanSlider(x.data, Slider);

            } else {
                //alert(x.pesan);
            }
        })
      },
      simpanSlider(gambar, Slider) {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          ke: Slider,
          gambar: gambar
        }
        
        var apiUrl = inter.SliderSimpan();
        myGlobal.call(datax,apiUrl).then(x => {            

            myGlobal.loger(x);

            if (x.status == true) {

              if (Slider == "1") {
                data.slider1loadingdone = true;
              }
              if (Slider == "2") {
                data.slider2loadingdone = true;
              }
              if (Slider == "3") {
                data.slider3loadingdone = true;
              }

            } else {
              this.form.alert = x.pesan;
            }

            data.slider1loading = false;
            data.slider2loading = false;
            data.slider3loading = false;

        })
      }
    }
    return {
      data,
      myGlobal,
      update
    }
  },
  mounted () {
    document.title = "Slider";

    this.data.tipe = sessionStorage.getItem('tipe');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.file-upload {
  position: relative !important;
  z-index: 0 !important;
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/slider.vue